"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvoInstallationId = void 0;
var AvoGuid_1 = require("./AvoGuid");
var AvoInspector_1 = require("./AvoInspector");
var AvoInstallationId = /** @class */ (function () {
    function AvoInstallationId() {
    }
    AvoInstallationId.getInstallationId = function () {
        if (AvoInstallationId.installationId !== null) {
            return AvoInstallationId.installationId;
        }
        if (!AvoInspector_1.AvoInspector.avoStorage.isInitialized()) {
            return "unknown";
        }
        var maybeInstallationId = AvoInspector_1.AvoInspector.avoStorage.getItem(AvoInstallationId.cacheKey);
        if (maybeInstallationId === null || maybeInstallationId === undefined) {
            AvoInstallationId.installationId = AvoGuid_1.default.newGuid();
            AvoInspector_1.AvoInspector.avoStorage.setItem(AvoInstallationId.cacheKey, AvoInstallationId.installationId);
        }
        else {
            AvoInstallationId.installationId = maybeInstallationId;
        }
        return AvoInstallationId.installationId;
    };
    Object.defineProperty(AvoInstallationId, "cacheKey", {
        get: function () {
            return "AvoInstallationId";
        },
        enumerable: false,
        configurable: true
    });
    AvoInstallationId.installationId = null;
    return AvoInstallationId;
}());
exports.AvoInstallationId = AvoInstallationId;
